import script from "./superAgentRight.vue?vue&type=script&setup=true&lang=js"
export * from "./superAgentRight.vue?vue&type=script&setup=true&lang=js"

import "./superAgentRight.vue?vue&type=style&index=0&id=5a8d6299&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a8d6299"]])

export default __exports__